import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'vex-mail-label-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule, MatDialogModule, MatButtonModule, MatCheckboxModule, MatIconModule, MatInputModule],
  template: `
    <div class="mail-label-dialog">
      <h2 class="mail-label-dialog__title">Manage Labels</h2>
      <p class="mail-label-dialog__subtitle">{{ data.count }} selected mails</p>

      <div class="mail-label-dialog__new">
        <input [(ngModel)]="newLabel" placeholder="Create new label" type="text" />
        <button (click)="addLabel()" color="primary" mat-stroked-button type="button">Add</button>
      </div>

      <div class="mail-label-dialog__list">
        <label *ngFor="let label of labels" class="mail-label-dialog__item">
          <mat-checkbox [(ngModel)]="selected[label]">{{ label }}</mat-checkbox>
        </label>
      </div>

      <div class="mail-label-dialog__actions">
        <button (click)="dialogRef.close()" mat-stroked-button type="button">Cancel</button>
        <button (click)="save()" color="primary" mat-flat-button type="button">Apply Labels</button>
      </div>
    </div>
  `,
  styles: [`
    .mail-label-dialog {
      width: min(460px, 100%);
      padding: 24px;
    }

    .mail-label-dialog__title {
      margin: 0;
      font-size: 20px;
      font-weight: 600;
    }

    .mail-label-dialog__subtitle {
      margin: 6px 0 0;
      font-size: 13px;
      color: rgba(15, 23, 42, 0.64);
    }

    .mail-label-dialog__new {
      display: flex;
      gap: 10px;
      margin-top: 18px;
    }

    .mail-label-dialog__new input {
      flex: 1 1 auto;
      height: 38px;
      border: 1px solid rgba(82, 63, 105, 0.18);
      border-radius: 6px;
      padding: 0 12px;
      outline: 0;
      background: transparent;
    }

    .mail-label-dialog__list {
      max-height: 280px;
      overflow: auto;
      margin-top: 16px;
      border: 1px solid rgba(82, 63, 105, 0.12);
      border-radius: 8px;
      padding: 8px 10px;
    }

    .mail-label-dialog__item {
      display: block;
      padding: 4px 0;
    }

    .mail-label-dialog__actions {
      display: flex;
      justify-content: flex-end;
      gap: 12px;
      margin-top: 18px;
    }
  `]
})
export class MailLabelDialogComponent {
  labels: string[] = [];
  selected: Record<string, boolean> = {};
  newLabel = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { labels: string[]; count: number },
    public dialogRef: MatDialogRef<MailLabelDialogComponent>
  ) {
    this.labels = [...data.labels];
    this.labels.forEach((label) => (this.selected[label] = false));
  }

  addLabel() {
    const label = this.newLabel.trim();
    if (!label || this.labels.includes(label)) {
      return;
    }

    this.labels = [...this.labels, label];
    this.selected[label] = true;
    this.newLabel = '';
  }

  save() {
    this.dialogRef.close(this.labels.filter((label) => this.selected[label]));
  }
}
